export default __webpack_public_path__ + "static/BHM_TeenVogue_Banners_1024x295-5b5658c769b7c6b54eaed2c905c3136e.jpg";